import jakePic from "@/public/images/artists/jake.png";
import { Artist } from "@/types/types";

export const jake = {
  id: "264",
  name: "Jake",
  image: jakePic,
  description: `Jake's voice is bright and smooth with a polished, modern pop-rock edge. There's a clear, open lift in his upper range that feels effortless, and his delivery blends emotional softness with a steady, full-bodied punch that cuts cleanly through a track.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjake-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Rock", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 45,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
